import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import { useEffect, useRef, useState } from "react";
import { DateRange } from "react-day-picker";
import CalenderBase from "../Calender/CalenderBase";
import useRouterHandlerHook from "../_hooks/useRouterHandlerHook";

const DateTimeInput = ({
  icon,
  className,
}: {
  icon: React.ReactNode;
  className: string;
}) => {
  const [month, setMonth] = useState<Date | undefined>(new Date());
  const [selected, setSelected] = useState<DateRange>();
  const hasClearedRef = useRef(false);
  const { navigateBackTo } = useRouterHandlerHook();
  useEffect(() => {
    if (hasClearedRef.current) return;

    hasClearedRef.current = true;
    navigateBackTo({ searchKey: "created_between" });
  }, []);
  return (
    <Popover className="relative">
      <PopoverButton className={className}>{icon}</PopoverButton>
      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-100 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <PopoverPanel
          as="div"
          anchor="left start"
          className="absolute border shadow-xl !shadow-extraLightGray
             border-extraLightGray rounded-lg bg-white z-50"
        >
          {({ close }) => (
            <CalenderBase
              month={month}
              onMonthChange={setMonth}
              selected={selected}
              setSelected={setSelected}
              close={close}
            />
          )}
        </PopoverPanel>
      </Transition>
    </Popover>
  );
};

export default DateTimeInput;
